export default {
    url: '/integrationlog',
    template: '<manage-logs-integrationlog></manage-logs-integrationlog>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/logs/integrationlog/index.js